import { useNavigate } from 'react-router-dom';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container'
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading'
import { useContext, useState } from 'react';
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import RenewableEnergyCertificateService from '../../../../shared/services/renewable-energy-certificate/renewable-energy-certificate.service';
import { IPostRenewableEnergyCertificate } from '../../../../shared/services/renewable-energy-certificate/renewable-energy-certificate.model';
import { RenewableEnergyCertificateForm } from '../../../presentation-components/organisation-components/rec-form';

export const OrganisationRenewableEnergyCertificateNewPage = () => {
  const navigate = useNavigate();
  //Services
  const renewableEnergyCertificateService = new RenewableEnergyCertificateService()
  //Context
  const userNotificationsContext = useContext(UserNotificationsContext)
  //State
  const [errorMessage, setErrorMessage] = useState<string>()
  const [errorCode, setErrorCode] = useState<number>()
  const [newRenewableEnergyCertificate, setNewRenewableEnergyCertificate] = useState<IPostRenewableEnergyCertificate>({
    name: '',
    notes: '',
    certificateNumber: '',
    registry: '',
    generationPeriod: '',
    energyMwh: 1,
    certificateType: '',
    retired: false,
    source: '',
    sourceOther: '',
  })
  //Loading State
  const [isFormSubmitting, setIsFormSubitting] = useState<boolean>(false)
  //Component Event Handlers
  const submitHandler = async (payload: { values: IPostRenewableEnergyCertificate, files: File[] }) => {
    if (!isFormSubmitting) {
      setIsFormSubitting(true)
      const form = new FormData();
      if (payload.files && payload.files.length > 0) {
        for (let i = 0; i < payload.files.length; i++) {
          form.append('files', payload.files[i]);
        }
      }
      form.append('renewableEnergyCertificate', JSON.stringify(payload.values));
      renewableEnergyCertificateService.createWithFile(form)
        .then(response => {
          setIsFormSubitting(false)
          userNotificationsContext.openSnackbar({ open: true, message: 'Saved successfully' });
          navigate(`/organisation/renewable-energy-certificates/${response.id}`)
        })
        .catch(err => {
          setIsFormSubitting(false)
          console.log(err)
          if (err.response.data.message) {
            setErrorMessage(err.response.data.message)
            setErrorCode(err.response.data.code)
          } else {
            userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
          }
        })
    } else {
      userNotificationsContext.openSnackbar({ open: true, message: 'Saving in progress, please wait' });
    }
  }

  return (
    <PageOuterContainer>
      <PageHeading
        title={`Add New Renewable Energy Certificate`}
        includeBackButton={true}
        backButtonLink='/organisation/renewable-energy-certificates'
        backButtonText={`Back to renewable energy certificates`}
      />
      <RenewableEnergyCertificateForm
        isSubmitting={isFormSubmitting}
        newRenewableEnergyCertificate={newRenewableEnergyCertificate}
        submitHandler={submitHandler}
        errorMessage={errorMessage}
        errorCode={errorCode}
        setErrorMessage={setErrorMessage}
        setErrorCode={setErrorCode}
      />
    </PageOuterContainer>
  )
} 